// @flow
import React from 'react';
import { Follow } from '@finect/tabular-components/Follow';
import { ProductInfo } from './ProductInfo';
import { ProfileInfo } from './ProfileInfo';
import { Actions, CardInner, Card } from './partials';

type Props = {
  type: string,
  entity: Object,
  follow: Function,
  following: boolean,
  onRefuse: Function,
  services: Object,
  isRefuse: boolean
};

export const IdentityCard = ({ type, entity, following, follow, onRefuse, isRefuse }: Props) => {
  let cardInfo;

  if (type === 'profile') cardInfo = <ProfileInfo entity={entity} />;
  else if (type === 'product') cardInfo = <ProductInfo entity={entity} />;

  if (!cardInfo) return null;

  return (
    <Card>
      <CardInner type="entity">
        {cardInfo}
        <Actions isRefuse={isRefuse}>
          <a
            href={`https://${process.env.FINECT_BASEURL || 'www.finect.com'}/mensajes/nuevo?members=${entity.id}`}
            rel="nofollow"
          >
            Enviar mensaje
          </a>
          {entity.subtype === 'profile' ? (
            <Follow following={following} follow={follow} small>
              Seguir
            </Follow>
          ) : (
            <span onClick={isRefuse ? onRefuse : null}>Rechazar</span>
          )}
        </Actions>
      </CardInner>
    </Card>
  );
};
